<div class="card" style="width:100%;" id="InsuredInfo">
    <ul class="nav nav-tabs listdata" role="tablist">
        <li role="presentation" class="active">
            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Insured Info' | translate }}</a>
        </li>

    </ul>
    <div class="tab-content detailsTab">
        <div role="tabpanel" class="tab-pane active" id="home">


            <div class="InsuredForm">
                <form #insuredForm="ngForm">
                    <div class="Field">
                        <div class="row">
                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Insured Name' | translate }}</label>
                                <input type="text" class="form-control" required id="txtName" name="txtName" required
                                    [(ngModel)]="prObj.Insured_Name" [disabled]="true" #txtName="ngModel" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Insured Name Required"></span>
                                <span *ngIf="txtName.invalid && (txtName.dirty || isSubmitted)"
                                    class="text-danger valid">
                                    <div *ngIf="txtName.errors.required">
                                        {{'Insured Name is required.'|translate }}
                                    </div>
                                </span>

                                 <i class="fa fa-question-circle" class="popoeverstyle"  data-toggle="popover"  data-content="Default popover"></i> -->
                            <!-- <label class="popoeverstyle"  data-toggle="popover"  data-content="Default popover">ss</label> 
                            </div> -->
                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Gender' | translate }}</label>

                                <select class="form-control" required name="txtGender" id="txtGender"
                                    [(ngModel)]="prObj.Gender" [disabled]="true" #txtGender="ngModel">
                                    <option value=""> {{'Select Gender'| translate }} </option>
                                    <option *ngFor="let gen of bindObj.GenderList" [value]="gen.gendercode">
                                        {{ Lng=="en"? gen.genderdesc_En : gen.GenderDesc_Ar }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Gender Required"></span>
                                <span *ngIf="txtGender.invalid && (txtGender.dirty || isSubmitted)"
                                    class="text-danger valid">
                                    <div *ngIf="txtGender.errors.required">
                                        {{ 'Gender is required'| translate }}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Date of birth' | translate }}</label>
                                <input type="text" class="form-control" required name="txtDOB" id="txtDOB"
                                    [(ngModel)]="prObj.Insured_DOB_DS" [disabled]="true" #txtDOB="ngModel" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="DOB Required"></span>
                                <span *ngIf="txtDOB.invalid && (txtDOB.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtDOB.errors.required">
                                        {{ 'DOB is required' | translate }}
                                    </div>
                                </span>
                            </div> -->
                        </div>

                        <div class="row">

                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Nationality' | translate }}</label>
                                <select class="form-control" required id="txtNat" name="txtNat"
                                    [(ngModel)]="prObj.addressObj.Insured_Nationality"
                                    [disabled]="prObj.addressObj.Insured_NationalityExists" #txtNat="ngModel">
                                    <option value=""> {{ 'Select Nationality' | translate }} </option>
                                    <option *ngFor="let nat of bindObj.NationalityMasterList"
                                        [value]="nat.NationalityDesc">
                                        {{Lng=="en"? nat.NationalityDescEn :nat.NationalityDescAr }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Nationality Required"></span>
                                <span *ngIf="txtNat.invalid && (txtNat.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtNat.errors.required">
                                        {{ 'Nationality is required'| translate}}
                                    </div>
                                </span>
                            </div> -->

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'City' | translate}} </label>
                                <select class="form-control" id="txtCity" required name="txtCity" [(ngModel)]="prObj.addressObj.Insured_City" [disabled]="prObj.addressObj.CityExists" #txtCity="ngModel" (change)="cityChange(prObj.addressObj.Insured_City)">
                                    <option value="">---{{ 'Select City' | translate}}--</option>
                                    <option *ngFor="let cty of bindObj.CityMasterList" [value]="cty.CITYNAME">
                                        {{ Lng=="en"? cty.CITYNAMEEn:cty.CITYNAMEAr }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="City Required"></span>
                                <span *ngIf="txtCity.invalid && (txtCity.dirty || txtCity.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtCity.errors?.required">
                                        {{ 'City is required' | translate}}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                                <label class="lbltext">{{ 'Building No' | translate}}</label>
                                <input type="text" class="form-control" required numbersOnly name="txtBuildingNumber" id="txtBuildingNumber" [(ngModel)]="prObj.addressObj.Insured_BuildingNo" [disabled]="prObj.addressObj.buildingNumberExists" #txtBuildingNumber="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Building No Required"></span>
                                <span *ngIf="txtBuildingNumber.invalid && (txtBuildingNumber.dirty || txtBuildingNumber.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtBuildingNumber.errors?.required">
                                        {{ 'BuildingNumber is required' | translate}}
                                    </div>
                                    <div *ngIf="txtBuildingNumber.errors?.pattern">
                                        {{ 'BuildingNumber must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtBuildingNumber.errors?.minlength">
                                        {{ 'BuildingNumber must be 4 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtBuildingNumber.errors?.maxlength">
                                        {{ 'BuildingNumber must be 4 digits' | translate}}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
                                <label class="lbltext">{{ 'Additional Code' | translate}}</label>
                                <input type="text" class="form-control" required numbersOnly name="txtAdditionalNumber" id="txtAdditionalNumber" [(ngModel)]="prObj.addressObj.Insured_AdditionalCode" [disabled]="prObj.addressObj.additionalNumberExists" #txtAdditionalNumber="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Default popover"></span>
                                <span *ngIf="txtAdditionalNumber.invalid && (txtAdditionalNumber.dirty || txtAdditionalNumber.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtAdditionalNumber.errors?.required">
                                        {{ 'AdditionalNumber is required' | translate}}
                                    </div>
                                    <div *ngIf="txtAdditionalNumber.errors?.pattern">
                                        {{ 'AdditionalNumber must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtAdditionalNumber.errors?.minlength">
                                        {{ 'AdditionalNumber must be 4 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtAdditionalNumber.errors?.maxlength">
                                        {{ 'AdditionalNumber must be 4 digits'| translate}}
                                    </div>
                                </span>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Street Name' | translate}}</label>
                                <input type="text" class="form-control" required name="txtStreetName" id="txtStreetName" [(ngModel)]="prObj.addressObj.Insured_StreetName" [disabled]="prObj.addressObj.streetNameExists" #txtStreetName="ngModel" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Street Required"></span>
                                <span *ngIf="txtStreetName.invalid && (txtStreetName.dirty || txtStreetName.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtStreetName.errors.required">
                                        {{ 'StreetName is required'| translate}}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'District Name' | translate}}</label>
                                <input type="text" class="form-control" required name="txtDistName" id="txtDistName" [(ngModel)]="prObj.addressObj.Insured_DistName" [disabled]="prObj.addressObj.districtExists" #txtDistName="ngModel" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="District Required"></span>
                                <span *ngIf="txtDistName.invalid && (txtDistName.dirty || txtDistName.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtDistName.errors.required">
                                        {{ 'District Name is required' | translate}}
                                    </div>
                                </span>
                            </div>

                            <!-- Step2 -->

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Vehicle Description'| translate}}</label>
                                <!-- <input  class="form-control" type="text" id="txtVehicleInfotxt" name="txtVehicleInfotxt" [(ngModel)]="prObj.VehicleDesc" [disabled]="true" *ngIf="bindObj.AutoData==null || bindObj.AutoData.length==1"/> -->
                                <select class="form-control" name="txtVehicleInfo" id="txtVehicleInfo" [(ngModel)]="prObj.VehicleDesc"   (change)="VehicleDescChange(prObj.VehicleDesc)">
                                    <option *ngIf="bindObj.AutoData==null || bindObj.AutoData.length==0">{{ prObj.VehicleDesc | translate}}</option>
                                    <option *ngFor="let rep of bindObj.AutoData"  [ngValue]="rep.VehicleDesc">{{rep.VehicleDesc }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Vehicle Info"></span>
                                <!-- <span *ngIf="txtRepair.invalid && (txtRepair.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtRepair.errors?.selectRequired">{{ 'Repair Type is required'| translate}}</div>
                                </span> -->
                            </div>


                        </div>
                        <div class="row">


                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Postal Code' | translate}}</label>
                                <input type="text" class="form-control" required name="txtPostalCode" id="txtPostalCode"
                                    [(ngModel)]="prObj.addressObj.Insured_POPostalCode"
                                    [disabled]="prObj.addressObj.postCodeExits" #txtPostalCode="ngModel" minlength="5"
                                    maxlength="5" pattern="^[1-9]\d*$" numbersOnly />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Postl Code Required"></span>
                                <span
                                    *ngIf="txtPostalCode.invalid && (txtPostalCode.dirty || txtPostalCode.touched || isSubmitted)"
                                    class="text-danger valid">
                                    <div *ngIf="txtPostalCode.errors?.required">
                                        {{ 'PostalCode is required' | translate}}
                                    </div>
                                    <div *ngIf="txtPostalCode.errors?.pattern">
                                        {{ 'PostalCode must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtPostalCode.errors?.minlength">
                                        {{ 'PostalCode must be 5 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtPostalCode.errors?.maxlength">
                                        {{'PostalCode must be 5 digits'| translate}}
                                    </div>
                                </span>

                            </div>  -->

                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Address Type' | translate}}</label>
                                <select class="form-control" id="txtAddessType" name="txtAddressType" required
                                    [(ngModel)]="prObj.addressObj.InsuredAddressType" #txtAddressType="ngModel">
                                    <option value=""> {{ 'Select Address Type'| translate}} </option>
                                    <option value="WaselAddress">{{'Wasel Address'| translate}}</option>
                                   
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Address Type Required"></span>
                                <span
                                    *ngIf="txtAddressType.invalid && (txtAddressType.dirty || isSubmitted || txtAddressType.touched)"
                                    class="text-danger valid">
                                    <div *ngIf="txtAddressType.errors.required">
                                        {{ 'Address Type is required' | translate}}
                                    </div>

                                </span>
                            </div>  -->



                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12"
                                *ngIf="prObj.addressObj.InsuredAddressType=='PostalAddress'">
                                <label class="lbltext">{{ 'Post BoxNo'| translate}}</label>
                                <input type="text" class="form-control"
                                    [required]="prObj.addressObj.InsuredAddressType=='PostalAddress'" numbersOnly
                                    name="txtPBox" id="txtPBox" [(ngModel)]="prObj.addressObj.Insured_POBoxNo"
                                    #txtPBox="ngModel" maxlength="6" pattern="^[1-9]\d*$" numbersOnly />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Postal Required"></span>
                                <span *ngIf="txtPBox.invalid && (txtPBox.dirty || isSubmitted || txtPBox.touched)"
                                    class="text-danger valid">
                                    <div *ngIf="txtPBox.errors?.required">
                                        {{ 'Post BoxNo is required'| translate}}
                                    </div>
                                    <div *ngIf="txtPBox.errors?.pattern">
                                        {{ 'Post Box Number must not start with zero'| translate}}
                                    </div>

                                </span>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Vehicle Value'| translate}}</label>
                                <input type="text" class="form-control" id="txtSumInsured" required [customMax]="prObj.MaxSumInsured" name="txtSumInsured" [(ngModel)]="prObj.SumInsured" numbersOnly #txtSumInsured="ngModel" (change)="VehicleValueChange()" [customMin]="prObj.MinSumInsured" maxlength="6" />
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Sum Insured"></span>
                                <span *ngIf="txtSumInsured.invalid && (txtSumInsured.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtSumInsured.errors.required">
                                        {{ 'SumInsured is required'| translate}}
                                    </div>
                                    <div *ngIf="txtSumInsured.errors?.customMin">
                                        {{ 'SumInsured must be greater than'| translate}} {{ prObj.MinSumInsured }}
                                    </div>
                                    <div *ngIf="txtSumInsured.errors?.customMax">
                                        {{ 'SumInsured must be less than'| translate}} {{ prObj.MaxSumInsured}}
                                    </div>
                                </span>
                            </div>



                            <!--  (change)="TestRepair(prObj.AgencyRepair)"!-->
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Repair Type'| translate}}</label>
                                <select class="form-control" selectRequired name="txtRepair" id="txtRepair" required [(ngModel)]="prObj.AgencyRepair" #txtRepair="ngModel" [disabled]="prObj.AgencyRepairExists" (change)="RepairTypeChange()">
                                    <option value="">--{{ 'Select Repair Type' | translate}}--</option>
                                    <option *ngFor="let rep of bindObj.repairList" [ngValue]="rep.AgencyCode">
                                        {{Lng=="en"?rep.AgencyDescEn:rep.AgencyDescAr }}</option>

                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Repair Type"></span>

                                <span *ngIf="txtRepair.invalid && (txtRepair.dirty || isSubmitted)" class="text-danger valid">
                                    <!-- <div *ngIf="txtRepair.errors.required">
                                        {{'Repair Type is required'| translate}}
                                    </div> -->
                                    <div *ngIf="txtRepair.errors?.selectRequired">
                                        {{ 'Repair Type is required'| translate}}
                                    </div>

                                </span>
                            </div>

                            <!-- bindObj.deductableList -->
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Deductible Type' | translate}}</label>
                                <select class="form-control" id="txtDeductable" name="txtDeductable" required [(ngModel)]="prObj.DeductableCode" #txtDeductable="ngModel">
                                    <option value="">--{{ 'Select Deductable'| translate}}--</option>
                                    <option *ngFor="let deduct of FilterDeductables()" [value]="deduct.DeductableCode">{{ deduct.DeductableDescEn }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" [attr.data-content]="DeducTooltip">
                                </span>
                                <span *ngIf="txtDeductable.invalid && (txtDeductable.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtDeductable.errors?.required">
                                        {{ 'Deductable is required'| translate}}
                                    </div>
                                </span>
                            </div>



                        </div>
                        <div class="row">
                            <div *ngIf="false" class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Use Restraints' | translate }}</label>
                                <select class="form-control" name="txtRestrains" id="txtRestrains" required [(ngModel)]="prObj.vehcileObj.Veh_Restraints" #txtRestrains="ngModel" (change)="chkRes(prObj.vehcileObj.Veh_Restraints)">
                                    <option ngValue="">--{{ 'Use Restraints' | translate }}--</option>
                                    <option *ngFor="let rep of bindObj.restrainList" [value]="rep.restraintID">
                                        {{ Lng=="en"?rep.restraintDescEn:rep.restraintDescAr }}</option>

                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Repair Type"></span>
                                <span *ngIf="txtRestrains.invalid && (txtRestrains.dirty || isSubmitted || txtRestrains.touched)" class="text-danger valid">
                                    <div *ngIf="txtRestrains.errors?.required">
                                        {{ 'Restrains is required' | translate }}
                                    </div>


                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngIf="prObj.Ins_MaritalStatusExists==false">
                                <label class="lbltext">{{ 'Marital Status'| translate}}</label>
                                <select class="form-control" selectRequired name="txtMaritalStatus" id="txtMaritalStatus" [(ngModel)]="prObj.Ins_MaritalStatus" #txtMaritalStatus="ngModel" [disabled]="prObj.Ins_MaritalStatusExists">
                                    <option [value]="0">{{'Select Marital Status' | translate }}</option>
                                    <option *ngFor="let marObj of bindObj.MarStatusList" [ngValue]="marObj.MarstatusCode">
                                        {{ Lng=="en"?marObj.MarstatusDesc_En:marObj.MarstatusDesc_Ar}}
                                    </option>

                                </select>
                                <span *ngIf="txtMaritalStatus.invalid && (txtMaritalStatus.dirty || isSubmitted || txtMaritalStatus.touched)" class="text-danger valid">
                                    <div *ngIf="txtMaritalStatus.errors?.selectRequired">
                                        {{ 'Marital Status is required'| translate}}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngIf="prObj.ModelExisted==false">
                                <label class="lbltext">{{ 'Vehicle Model'| translate}}</label>
                                <select class="form-control" selectRequired name="txtVeh" id="txtVeh" [(ngModel)]="prObj.vehcileObj.Vehicle_ModelCode" #txtVeh="ngModel" (change)="getModelInfo()">
                                    <option [value]="0">{{'Select Vehicle Model' | translate }}</option>
                                    <option *ngFor="let modelObj of bindObj.ModelMasterList" [ngValue]="modelObj.MODELDESC">
                                        {{ Lng=="en"?modelObj.MODELDESCEn:modelObj.MODELDESCAr}}
                                    </option>

                                </select>
                                <span *ngIf="txtVeh.invalid && (txtVeh.dirty || isSubmitted || txtVeh.touched)" class="text-danger valid">
                                    <div *ngIf="txtVeh.errors?.selectRequired">
                                        {{ 'Vehicle Model is required'| translate}}
                                    </div>
                                </span>
                            </div>

                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'vehicle Color' | translate }}</label>
                                <select class="form-control" selectRequired name="txtColor" id="txtColor"
                                    [(ngModel)]="prObj.vehcileObj.Vehicle_ColorID" #txtColor="ngModel"
                                    [disabled]="prObj.VechileColorExists">
                                    <option value="0"> {{ 'Select Color' | translate }} </option>
                                    <option *ngFor="let rep of bindObj.VechileColorList" [ngValue]="rep.ColorId">
                                        {{Lng=="en"?rep.ColorDescEn:rep.ColorDescAr }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Repair Type"></span>
                                <span *ngIf="txtColor.invalid && (txtColor.dirty || isSubmitted || txtColor.touched)"
                                    class="text-danger valid">
                                    <div *ngIf="txtColor.errors?.selectRequired">
                                        {{ 'Color is required' | translate}}
                                    </div>


                                </span>
                            </div> -->

                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'USE OF Vehicle'| translate}}</label>
                                <select class="form-control" selectRequired name="txtUV" id="txtUV"
                                    [(ngModel)]="prObj.vehcileObj.Vehicle_UsageCode" #txtUV="ngModel"
                                    [disabled]="prObj.VechileUsageCodeExits"
                                    (ngModelChange)="getVehileUsage(prObj.vehcileObj.Vehicle_UsageCode)">
                                    <option value="0"> {{ 'Select Use of Vehicle'| translate}} </option>
                                    <option *ngFor="let rep of bindObj.VehcielUsageList" [ngValue]="rep.VehUsagecode">
                                        {{Lng=="en"?rep.VehUsage_DescEn:rep.Vehusage_DescAr }}</option>
                                </select>
                                <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover"
                                    data-content="Repair Type"></span>
                                <span *ngIf="txtUV.invalid && (txtUV.dirty || isSubmitted || txtUV.touched)"
                                    class="text-danger valid">
                                    <div *ngIf="txtUV.errors?.selectRequired">
                                        {{ 'Use of Vehicle is required'| translate}}
                                    </div>


                                </span>
                            </div> -->
                        </div>
                        <div class="row">

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Vehicle Kept at night'| translate}}</label>
                                <select class="form-control" selectRequired name="txtVehicleKept" id="txtVehicleKept" [(ngModel)]="prObj.vehcileObj.VehicleParkingNight" #txtVehicleKept="ngModel">
                                    <option [value]="0">{{'Select Vehicle Parking at Night' | translate }}</option>
                                    <option *ngFor="let vehilekeptObj of bindObj.vehicleKeptList" [value]="vehilekeptObj.CODE">
                                        {{ Lng=="en"?vehilekeptObj.DESC_ENG:vehilekeptObj.DESC_AR}}
                                    </option>

                                </select>
                                <span *ngIf="txtVehicleKept.invalid && (txtVehicleKept.dirty || isSubmitted || txtVehicleKept.touched)" class="text-danger valid">
                                    <div *ngIf="txtVehicleKept.errors?.selectRequired">
                                        {{ 'Vehicle Parking at Night is required'| translate}}
                                    </div>

                                </span>



                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngIf="prObj.vehcileObj.Vehicle_DefType==2">
                                <label class="lbltext">{{ 'Vehicle Registration Date'| translate}}</label>
                                <input class="form-control" type="text" required id="VehicleRegDate" name="VehicleRegDate" [(ngModel)]="prObj.vehcileObj.Vehicle_RegExpirydateHijri" #VehicleRegDate="ngModel" [disabled]="prObj.VehicleRegExpiryExists==true" HijriPicker (ngModelChange)="getHijri($event)" autocomplete="off" />

                                <span *ngIf="VehicleRegDate.invalid && (VehicleRegDate.dirty || isSubmitted || VehicleRegDate.touched)" class="text-danger valid">
                                    <div *ngIf="VehicleRegDate.errors?.required">
                                        {{ 'Vehicle Registration Date is required'| translate}}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Education'| translate}}</label>
                                <select class="form-control" name="txtEducation" id="txtEducation" selectRequired [(ngModel)]="prObj.InsuredEducation" selectRequired #txtEducation="ngModel">
                                    <option [value]="0">{{'Select Education' | translate }}</option>
                                    <option *ngFor="let eduObj of bindObj.eduList" [value]="eduObj.EducationCode">
                                        {{Lng=="en"?eduObj.EducationDesc_En:eduObj.EducationDesc_Ar}}</option>
                                </select>
                                <span *ngIf="txtEducation.invalid && (txtEducation.dirty || isSubmitted || txtEducation.touched)" class="text-danger valid">
                                    <div *ngIf="txtEducation.errors.selectRequired">
                                        {{ 'Education is required'| translate}}
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Profession'| translate}}</label>
                                <select class="form-control" name="txtProfession" id="txtProfession" selectRequired #txtProfession="ngModel" [(ngModel)]="prObj.InsuredProfessin">
                                    <option [value]="0">{{ 'Select Profession' | translate }} </option>
                                    <option *ngFor="let profObj of bindObj.profList" [value]="profObj.Professioncode">
                                        {{Lng=="en"?profObj.ProfessionDesc_Eng:profObj.ProfessionDesc_Ar}}</option>
                                </select>
                                <span *ngIf="txtProfession.invalid && (txtProfession.dirty || isSubmitted || txtProfession.touched)" class="text-danger valid">
                                    <div *ngIf="txtProfession.errors?.selectRequired">
                                        {{ 'Profession is required'| translate}}
                                    </div>
                                </span>

                            </div>

                            <!-- <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                        <label class="lbltext">{{ 'Children Under 16 years'| translate}}</label>
                                        <input type="text" class="form-control" name="txtchildren" id="txtchildren" required numbersOnly #txtchildren="ngModel"  [(ngModel)]="prObj.ChildrenUnder"
                                                maxlength="2">

                                                <span *ngIf="txtchildren.invalid && (txtchildren.dirty || isSubmitted || txtchildren.touched)" class="text-danger valid">
                                                        <div *ngIf="txtchildren.errors?.required">
                                                                {{ 'Children Under 16 years is required'| translate}}
                                                        </div>


                                                </span>

                                </div> -->
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Children Under 16 years'| translate}}</label>
                                <select class="form-control" name="txtchildren" id="txtchildren" selectRequired #txtchildren="ngModel" [(ngModel)]="prObj.ChildrenUnder">
                                    <option [value]="0">{{ 'Select Children Under 16 Years' | translate }}</option>
                                    <option *ngFor="let under16 of bindObj.ChildrenUnder16List" [value]="under16.CODE">
                                        {{Lng=="en"?under16.CHILDREN_COUNT_EN:under16.CHILDREN_COUNT_AR}}</option>
                                </select>
                                <span *ngIf="txtchildren.invalid && (txtchildren.dirty || isSubmitted || txtchildren.touched)" class="text-danger valid">
                                    <div *ngIf="txtchildren.errors?.selectRequired">
                                        {{ 'Children Under 16 years is required'|translate}}</div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Other Countries Licence Held'| translate}}</label>
                                <select class="form-control" id="txtOtherCountryLicenseHeld" selectRequired name="txtOtherCountryLicenseHeld" [(ngModel)]="prObj.insuredDriverObj.OtherCountriesLicenceHeld" #txtOtherCountryLicenseHeld="ngModel">
                                    <option [value]="0">{{'Select Other Countries License Held' | translate}}</option>
                                    <option *ngFor="let nat of bindObj.NationalityMasterList" [value]="nat.NationalityDesc">
                                        {{Lng=="en"? nat.NationalityDescEn :nat.NationalityDescAr }}</option>
                                </select>
                                <span *ngIf="txtOtherCountryLicenseHeld.invalid && (txtOtherCountryLicenseHeld.dirty || txtOtherCountryLicenseHeld.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOtherCountryLicenseHeld.errors?.selectRequired">
                                        {{'Other Countries Licence Held is required' | translate}}</div>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'No of Years License Held for Each Country'| translate}}</label>
                                <select class="form-control" id="txtYearsEachCountry" selectRequired name="txtYearsEachCountry" [(ngModel)]="prObj.insuredDriverObj.NumberOfYearsEachCountry" #txtYearsEachCountry="ngModel">
                                    <option [value]="0">{{'Select each country license held' | translate}}</option>
                                    <option *ngFor="let year of bindObj.LicenceForEachCountryList" [value]="year.CODE">
                                        {{Lng=="en"?year.DRIVING_LICENSE_YEARS_EN: year.DRIVING_LICENSE_YEARS_AR }}
                                    </option>
                                </select>
                                <span *ngIf="txtYearsEachCountry.invalid && (txtYearsEachCountry.dirty || txtYearsEachCountry.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtYearsEachCountry.errors?.selectRequired">
                                        {{'No of Years License Held for Each Country is required' | translate}}</div>
                                </span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'No Of Years Saudi Licence Held'| translate}}</label>
                                <select class="form-control" id="txtSaudiLicenseHeld" CustomNumberDirective name="txtSaudiLicenseHeld" [(ngModel)]="prObj.insuredDriverObj.SaudiLicenceHeld" #txtSaudiLicenseHeld="ngModel">
                                    <option [value]="-1">{{'Select Saudi License Held' | translate}}</option>
                                    <option *ngFor="let year of bindObj.NumYearList" [value]="year.numYearCode">
                                        {{year.numYear }}</option>
                                </select>
                                <span *ngIf="txtSaudiLicenseHeld.invalid && (txtSaudiLicenseHeld.dirty || txtSaudiLicenseHeld.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtSaudiLicenseHeld.errors?.CustomNumberDirective">
                                        {{'No Of Years Saudi Licence Held is required' | translate}}</div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngIf="prObj.LicenceExpiryDateExists==false">
                                <label class="lbltext">{{ 'Insured Licence Expiry Date'| translate}}</label>
                                <input class="form-control" type="text" required id="InsuredLicDate" name="InsuredLicDate" [(ngModel)]="prObj.LicenceExpiryDateH" #InsuredLicDate="ngModel" [disabled]="prObj.LicenceExpiryDateExists==true" HijriPicker (ngModelChange)="getHijri($event)" autocomplete="off" />

                                <span *ngIf="InsuredLicDate.invalid && (InsuredLicDate.dirty || isSubmitted || InsuredLicDate.touched)" class="text-danger valid">
                                    <div *ngIf="InsuredLicDate.errors?.required">
                                        {{ 'Insured Licence Expiry Date is required'| translate}}
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Road Convictions'| translate}}</label>
                                <div class="roadconvictions">
                                    <select style="width:auto;border-right: none;border-left: none;border-top: none;" class="form-control" name="txtRoadConvictions" id="txtRoadConvictions" [(ngModel)]="prObj.insuredDriverObj.RoadConvictions" selectRequired #txtRoadConvictions="ngModel">
                                        <option [value]="0">{{'Select Road Convictions' | translate}}</option>
                                        <option *ngFor="let road of bindObj.RoadConvictionList" [value]="road.RoadConviction_ID">
                                            {{Lng=="en"?road.RoadConviction_Eng:road.RoadConviction_Ar}}</option>
                                    </select>
                                </div>
                                <span *ngIf="txtRoadConvictions.invalid && (txtRoadConvictions.dirty || isSubmitted || txtRoadConvictions.touched)" class="text-danger valid">
                                    <div *ngIf="txtRoadConvictions.errors?.selectRequired">
                                        {{ 'Road Convictions is required'| translate}}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Medical Conditions as Stated in the driving licence '| translate }}</label>
                                <select name="txtdrivingMedConditions" id="txtdrivingMedConditions" class="form-control" selectRequired [(ngModel)]="prObj.insuredDriverObj.DriverMedicalConditions" #txtdrivingMedConditions="ngModel" >
                                    <option [value]="0">{{'Select Medical Condition' | translate}}</option>
                                    <option *ngFor="let medObj of bindObj.restrainList" [value]="medObj.restraintID">
                                        {{ Lng=="en"?medObj.restraintDescEn:medObj.restraintDescAr }}</option>
                                </select>
                                <span *ngIf="txtdrivingMedConditions.invalid && (txtdrivingMedConditions.dirty || isSubmitted || txtdrivingMedConditions.touched)" class="text-danger valid">
                                    <div *ngIf="txtdrivingMedConditions.errors?.selectRequired">
                                        {{ 'Medical Conditions as Stated in the driving licence is required'| translate}}
                                    </div>
                                </span>
                            </div>

                            <!-- Step1 style="height: 48px; overflow-x:auto;"-->
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext" style="margin-bottom: 22px;">{{ 'Transmission'| translate}}</label>
                                <select class="form-control" name="txtTransmission" id="txtTransmission" #txtTransmission="ngModel" selectRequired [(ngModel)]="prObj.vehcileObj.Transmission" >
                                    <option [value]="0">{{'Select Transmission' | translate }}</option>
                                    <option *ngFor="let transObj of bindObj.transmissionList" [value]="transObj.Code">
                                        {{Lng=="en"?transObj.Desc_Eng:transObj.Desc_Ar }}
                                    </option>
                                </select>

                                <span *ngIf="txtTransmission.invalid && (txtTransmission.dirty || isSubmitted || txtTransmission.touched)" class="text-danger valid">
                                    <div *ngIf="txtTransmission.errors.selectRequired">
                                        {{ 'Transmission is required'| translate}}
                                    </div>

                                </span>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12" *ngIf="this.prObj.addressObj.Insured_Nationality=='17'">
                                <label class="lbltext">{{ 'American ID'| translate}}</label>
                                <input class="form-control" id="txtamericanID" name="txtamericanID" minlength="4" maxlength="15" (keypress)="ValidateSpecialChar($event)" required [(ngModel)]="prObj.AmericanID" #txtamericanID="ngModel">
                                <span *ngIf="txtamericanID.invalid && (txtamericanID.dirty || txtamericanID.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtamericanID.errors?.required">
                                        {{'American ID is required' | translate}}</div>
                                    <div *ngIf="txtamericanID.errors?.minlength">
                                        {{'American ID must be atleast 3 digits' | translate}}</div>
                                    <div *ngIf="txtamericanID.errors?.maxlength">
                                        {{'American ID must be maximum 15 digits' | translate}}</div>
                                </span>
                            </div>
                        </div>



                        <!-- Start New Field Added '2020-02-05' -->

                        <!-- <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Policy Effective Date'| translate }}</label>
                                <input type="text" id="txtPolicyEffecDate" name="txtPolicyEffecDate" bsDatepicker class="form-control" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }"
                                    [(ngModel)]="prObj.ProposalEffFrom" (ngModelChange)="GetPolicyExpiry(prObj.ProposalEffFrom)"
                                    #txtPolicyEffecDate="ngModel" [minDate]="minDate" [maxDate]="maxDate" required autocomplete="off">
                                <span *ngIf="txtPolicyEffecDate.invalid && (txtPolicyEffecDate.dirty || isSubmitted || txtPolicyEffecDate.touched)" class="text-danger valid">
                                    <div *ngIf="txtPolicyEffecDate.errors?.required">
                                        {{ 'Policy Effective Date is required'| translate}}
                                    </div>
                                    <div *ngIf="txtPolicyEffecDate.errors?.minDate">
                                        {{ 'Invalid Policy Effective Date'| translate}}
                                    </div>
                                    <div *ngIf="txtPolicyEffecDate.errors?.maxDate">
                                        {{ 'Invalid Policy Effective Date'| translate}}
                                    </div>
                                </span>
                            </div>

                        </div> -->
                        <div class="row" style="margin-top:20px;border:1px solid gray;padding-bottom:20px;">
                            <ul class="nav nav-tabs listdata policyeffectivedate" role="tablist">
                                <li role="presentation" class="active">
                                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Policy Period Information' | translate }}</a>
                                </li>

                            </ul>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Policy Effective Date'| translate }}</label>
                                <input type="text" id="txtPolicyEffecDate" name="txtPolicyEffecDate" bsDatepicker class="form-control" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }" [(ngModel)]="prObj.ProposalEffFrom" (ngModelChange)="GetPolicyExpiry(prObj.ProposalEffFrom)" #txtPolicyEffecDate="ngModel" [minDate]="minDate" [maxDate]="maxDate" required autocomplete="off">
                                <span *ngIf="txtPolicyEffecDate.invalid && (txtPolicyEffecDate.dirty || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtPolicyEffecDate.errors.required">
                                        {{ 'Policy Effective Date is required'| translate}}
                                    </div>
                                    <div *ngIf="txtPolicyEffecDate.errors.minDate">
                                        {{ 'Invalid Policy Effective Date'| translate}}
                                    </div>
                                    <div *ngIf="txtPolicyEffecDate.errors.maxDate">
                                        {{ 'Invalid Policy Effective Date'| translate}}
                                    </div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{'Policy Expiry Date'| translate }}</label>
                                <input type="text" id="txtPolicyEffecTo" name="txtPolicyEffecTo" class="form-control" placeholder="{{policyToDate}}" [disabled]="true">
                            </div>
                        </div>
                        <!-- End New Field Added '2020-02-05' -->

                        <div class="row" style="margin-top:15px;margin-left:2px;">
                            <h5 class="addresslabel">{{'Office Address'|translate}}</h5>
                        </div>

                        <div class="row">

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Building No'| translate}}</label>
                                <input type="text" class="form-control" name="txtOfficeBuildNo" id="txtOfficeBuildNo" numbersOnly #txtOfficeBuildNo="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" [(ngModel)]="prObj.addressObj.OfficeBuildingNo">
                                <span *ngIf="txtOfficeBuildNo.invalid && (txtOfficeBuildNo.dirty || txtOfficeBuildNo.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOfficeBuildNo.errors?.required">
                                        {{ 'BuildingNumber is required' | translate}}
                                    </div>
                                    <div *ngIf="txtOfficeBuildNo.errors?.pattern">
                                        {{ 'BuildingNumber must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtOfficeBuildNo.errors?.minlength">
                                        {{ 'BuildingNumber must be 4 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtOfficeBuildNo.errors?.maxlength">
                                        {{ 'BuildingNumber must be 4 digits' | translate}}
                                    </div>
                                </span>

                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office City'| translate}}</label>
                                <select class="form-control" id="txtOfficeCity" name="txtOfficeCity" [(ngModel)]="prObj.addressObj.OfficeCity" #txtOfficeCity="ngModel" (change)="OfficecityChange(prObj.addressObj.OfficeCity)">
                                    <option value="0">---{{ 'Select City' | translate}}--</option>
                                    <option *ngFor="let cty of bindObj.CityMasterList" [value]="cty.CITYNAME">
                                        {{ Lng=="en"? cty.CITYNAMEEn:cty.CITYNAMEAr}}</option>
                                </select>
                                <span *ngIf="txtOfficeCity.invalid && (txtOfficeCity.dirty || txtOfficeCity.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOfficeCity.errors?.selectRequired">
                                        {{ 'City is required' | translate}}</div>
                                </span>

                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Postal Code'| translate}}</label>
                                <input type="text" class="form-control" name="txtPostType" id="txtPostType" #txtPostType="ngModel" minlength="5" maxlength="5" pattern="^[1-9]\d*$" [(ngModel)]="prObj.addressObj.OfficePostalCode" numbersOnly>
                                <span *ngIf="txtPostType.invalid && (txtPostType.dirty || txtPostType.touched || isSubmitted)" class="text-danger valid">

                                    <div *ngIf="txtPostType.errors?.pattern">
                                        {{ 'PostalCode must not start with zero' | translate}}
                                    </div>
                                    <div *ngIf="txtPostType.errors?.required">
                                        {{ 'PostalCode must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtPostType.errors?.minlength">
                                        {{ 'PostalCode must be 5 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtPostType.errors?.maxlength">
                                        {{'PostalCode must be 5 digits'| translate}}
                                    </div>
                                </span>
                            </div>
                        </div>

                        <div class="row">

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Additional Code'| translate}}</label>
                                <input type="text" class="form-control" name="txtOfficeAddCode" id="txtOfficeAddCode" numbersOnly #txtOfficeAddCode="ngModel" minlength="4" maxlength="4" pattern="^[1-9]\d*$" [(ngModel)]="prObj.addressObj.OfficeAdditionalCode">
                                <span *ngIf="txtOfficeAddCode.invalid && (txtOfficeAddCode.dirty || txtOfficeAddCode.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOfficeAddCode.errors?.required">
                                        {{ 'AdditionalNumber is required' | translate}}
                                    </div>
                                    <div *ngIf="txtOfficeAddCode.errors?.pattern">
                                        {{ 'AdditionalNumber must not start with zero' | translate}}
                                    </div>

                                    <div *ngIf="txtOfficeAddCode.errors?.minlength">
                                        {{ 'AdditionalNumber must be 4 digits' | translate}}
                                    </div>
                                    <div *ngIf="txtOfficeAddCode.errors?.maxlength">
                                        {{ 'AdditionalNumber must be 4 digits'| translate}}
                                    </div>
                                </span>
                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Street Name'| translate}}</label>
                                <input type="text" class="form-control" name="txtStreet" id="txtStreet" [(ngModel)]="prObj.addressObj.OfficeStreet" #txtStreet="ngModel">
                                <span *ngIf="txtStreet.invalid && (txtStreet.dirty || txtStreet.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtStreet.errors?.required">{{ 'Street Name is required' | translate}}
                                    </div>
                                </span>

                            </div>

                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Disrtict Name'| translate}}</label>
                                <input type="text" class="form-control" name="txtDistrict" id="txtDistrict" [(ngModel)]="prObj.addressObj.OfficeDistrict" #txtDistrict="ngModel">
                                <span *ngIf="txtDistrict.invalid && (txtDistrict.dirty || txtDistrict.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtDistrict.errors?.required">
                                        {{ 'Disrtict Name is required' | translate}}</div>
                                </span>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Unit No'| translate}}</label>
                                <input type="text" class="form-control" numbersOnly minlength="1" maxlength="5" name="txtOffcUnitNo" id="txtOffcUnitNo" [(ngModel)]="prObj.addressObj.OfficeUnitNo" #txtOffcUnitNo="ngModel">
                                <span *ngIf="txtOffcUnitNo.invalid && (txtOffcUnitNo.dirty || txtOffcUnitNo.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOffcUnitNo.errors?.required">
                                        {{ 'Office Unit No is required' | translate}}</div>
                                    <div *ngIf="txtOffcUnitNo.errors?.minlength">
                                        {{ 'Office Unit No must be 1 digit' | translate}}</div>
                                    <div *ngIf="txtOffcUnitNo.errors?.maxlength">
                                        {{ 'Office Unit No must be 1 digit' | translate}}</div>
                                </span>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                <label class="lbltext">{{ 'Office Zone'| translate}}</label>
                                <input type="text" class="form-control" required name="txtOffcZone" id="txtOffcZone" [(ngModel)]="prObj.addressObj.OfficeZone" #txtOffcZone="ngModel" [disabled]="true">
                                <span *ngIf="txtOffcZone.invalid && (txtOffcZone.dirty || txtOffcZone.touched || isSubmitted)" class="text-danger valid">
                                    <div *ngIf="txtOffcZone.errors?.required">{{ 'Office Zone is required' | translate}}
                                    </div>

                                </span>
                            </div>
                        </div>


                    </div>

                    <div class="Field">
                        <div class="row">

                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <label class="AdditionalDrivers"> {{'b1' | translate }}</label>
                                <label class="AdditionalDrivers">
                                    <label>
                                        <input type="radio" name="radisCommercial" id="radisCommercial" [(ngModel)]="prObj.IsItCommercial" [value]="true" [disabled]="true" (change)="oncommercialSelectionChange(prObj.IsItCommercial)" />
                                        {{'Yes'| translate}}</label>
                                    <label>
                                        <input type="radio" name="radisCommercial" id="radisCommercial" [(ngModel)]="prObj.IsItCommercial" [value]="false" [disabled]="true" (change)="oncommercialSelectionChange(prObj.IsItCommercial)" />
                                        {{ 'No'| translate}}</label>
                                </label>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <label class="AdditionalDrivers">{{'b5' | translate }} </label>
                                <label class="AdditionalDrivers">
                                    <label>
                                        <input type="radio" name="radmet" id="radmet" [value]="true" [(ngModel)]="prObj.MetAccident" /> {{'Yes' | translate }}</label>
                                    <label>
                                        <input type="radio" name="radmet" id="radmet" [value]="false" [(ngModel)]="prObj.MetAccident" /> {{ 'No' | translate }}</label>
                                </label>
                            </div>

                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="prObj.MetAccident">
                                <label class="AdditionalDrivers">{{ 'Enter Notes'| translate}} </label>
                                <label class="AdditionalDrivers">
                                    <label>
                                        <input type="text" name="txtradmetNotes" id="txtradmetNotes" class="form-control" [required]="prObj.MetAccident" [(ngModel)]="prObj.MetAccidentRemarks" #txtradmetNotes="ngModel" />
                                    </label>
                                </label>
                                <span *ngIf="txtradmetNotes.invalid && (txtradmetNotes.dirty || isSubmitted || txtradmetNotes.touched)" class="text-danger valid">
                                    <div *ngIf="txtradmetNotes.errors?.required">
                                        {{ 'Notes is required'| translate}}
                                    </div>

                                </span>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <label class="AdditionalDrivers">{{'b2' |translate }}</label>
                                <label class="AdditionalDrivers">
                                    <label>
                                        <input type="radio" name="txtVehKept" id="txtVehKept" [value]="true" [(ngModel)]="prObj.vechilekept" /> {{' Yes' | translate }}</label>
                                    <label>
                                        <input type="radio" name="txtVehKept" id="txtVehKept" [value]="false" [(ngModel)]="prObj.vechilekept" /> {{ 'No' | translate }}</label>
                                </label>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="!prObj.vechilekept">
                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <label>{{ 'District Name' | translate }}</label>

                                    <select class="form-control" [required]="!prObj.vechilekept" name="txtVechileDist" id="txtVechileDist" [(ngModel)]="prObj.vehcileObj.Insured_RiskDistName" #txtVechileDist="ngModel">
                                        <option value="">--{{ 'Select District' | translate}}--</option>
                                        <option *ngFor="let rep of bindObj.disList" [value]="rep.DisCode">
                                            {{ Lng=="en"?rep.DistrictNameEng:rep.DistrictNameAr }}</option>
                                    </select>
                                    <div *ngIf="prObj.vehcileObj.Insured_RiskDistName==2">
                                        <input type="text" class="form-control" id="txtDistrictDesc" name="txtDistrictDesc" style="margin-top:5px;" placeholder="{{'Enter Disrict Name' | translate}}" [(ngModel)]="prObj.vehcileObj.Veh_DistrictDesc" [required]="prObj.vehcileObj.Insured_RiskDistName==2" #txtDistrictDesc="ngModel" />
                                        <span *ngIf="txtDistrictDesc.invalid && (txtDistrictDesc.dirty || isSubmitted || txtDistrictDesc.touched)" class="text-danger valid">
                                            <div *ngIf="txtDistrictDesc.errors?.required">
                                                {{ 'District Name is required'| translate}}
                                            </div>

                                        </span>
                                    </div>

                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="District Required"></span>
                                    <span *ngIf="txtVechileDist.invalid && (txtVechileDist.dirty || isSubmitted || txtVechileDist.touched)" class="text-danger valid">
                                        <div *ngIf="txtVechileDist.errors?.required">
                                            {{ 'District is required' | translate}}
                                        </div>

                                    </span>


                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <label>{{ 'Street Name' | translate}}</label>
                                    <select class="form-control" [required]="!prObj.vechilekept" name="txtVehStreet" id="txtVehStreet" [(ngModel)]="prObj.vehcileObj.Insured_RiskStreetName" #txtVehStreet="ngModel">
                                        <option value="">--{{'Select Street Name' | translate}}--</option>
                                        <option *ngFor="let rep of bindObj.streetList" [value]="rep.StreetCode">
                                            {{Lng=="en"?rep.StreetNameEng:rep.StreetNameAr }}</option>

                                    </select>
                                    <div *ngIf="prObj.vehcileObj.Insured_RiskStreetName==2">
                                        <input type="text" class="form-control" id="txtVStreetDesc" name="txtVStreetDesc" style="margin-top:5px;" placeholder="{{'Enter Street Name' | translate}}" [(ngModel)]="prObj.vehcileObj.Veh_StreetDesc" [required]="prObj.vehcileObj.Insured_RiskStreetName==2" #txtVStreetDesc="ngModel" />
                                        <span *ngIf="txtVStreetDesc.invalid && (txtVStreetDesc.dirty || isSubmitted || txtVStreetDesc.touched)" class="text-danger valid">
                                            <div *ngIf="txtVStreetDesc.errors?.required">
                                                {{ 'Street Name is required'| translate}}
                                            </div>
                                        </span>
                                    </div>

                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="Street Required"></span>
                                    <span *ngIf="txtVehStreet.invalid && (txtVehStreet.dirty || isSubmitted || txtVehStreet.touched)" class="text-danger valid">
                                        <div *ngIf="txtVehStreet.errors?.required">
                                            {{ 'Street is required'| translate}}
                                        </div>

                                    </span>





                                </div>


                                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                                    <label>City</label>
                                    <select class="form-control" selectRequired="!prObj.vechilekept" name="txtVehCity" id="txtVehCity" [(ngModel)]="prObj.vehcileObj.Insured_RiskCity" #txtVehCity="ngModel">
                                        <option [value]="0">--{{ 'Select City Name'| translate}}--</option>
                                        <option *ngFor="let rep of bindObj.CityMasterList" [value]="rep.CITYNAME">
                                            {{Lng=="en"?rep.CITYNAMEEn:rep.CITYNAMEAr }}</option>

                                    </select>
                                    <span class="glyphicon glyphicon-question-sign popoeverstyle" data-toggle="popover" data-content="City is Required"></span>
                                    <span *ngIf="txtVehCity.invalid && (txtVehCity.dirty || isSubmitted || txtVehCity.touched)" class="text-danger valid">
                                        <div *ngIf="txtVehCity.errors?.selectRequired">
                                            {{'City is required'| translate}}
                                        </div>


                                    </span>
                                </div>
                            </div>




                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 AddAdditionalDrivers">
                                <label class="AdditionalDrivers AdditionalDriversLabelHeading">{{'b3' | translate }}
                                </label>
                                <label class="AdditionalDrivers AdditionalDriversCheckbox">
                                    <label>
                                        <input type="radio" name="mainDriver" id="rad1" [value]="true" [(ngModel)]="prObj.isInsuredMainDriver" [disabled]="prObj.isDriverMandatory" (change)="CheckMainDriver($event,prObj.isInsuredMainDriver)" />
                                        {{'Yes'| translate }}</label>
                                    <label>
                                        <input type="radio" name="mainDriver" id="rad2" [value]="false" [(ngModel)]="prObj.isInsuredMainDriver" [disabled]="prObj.isDriverMandatory" (change)="CheckMainDriver($event,prObj.isInsuredMainDriver)" />
                                        {{'No' | translate}}</label>
                                </label>
                            </div>




                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 AddAdditionalDrivers">
                                <label class="AdditionalDrivers AdditionalDriversLabelHeadingb4" style="width: 440px;">{{'b4'| translate}}
                                </label>
                                <label class="AdditionalDrivers">
                                    <label>
                                        <input type="radio" name="additional" id="addRad1" [value]="true" [(ngModel)]="prObj.isDriverRequired" [disabled]="disableAddDrivers==true" (change)="checkDrivers(prObj.isDriverRequired)" />
                                        {{'Yes' | translate }}</label>
                                    <label>
                                        <input type="radio" name="additional" id="addRad2" [value]="false" [(ngModel)]="prObj.isDriverRequired" [disabled]="disableAddDrivers==true" (change)="checkDrivers(prObj.isDriverRequired)" />
                                        {{'No' | translate }}</label>
                                </label>
                            </div>

                        </div>
                    </div>

                    <div class="Field">
                        <div class="row">

                            <div class="alert alert-danger" role="alert" *ngIf="prObj.st.StatusCode=='F'">
                                {{ prObj.st.StatusDesc }}
                            </div>



                        </div>
                    </div>
                </form>

                <hr class="hr" />
                <div class="ButtonActions ">
                    <div class="btn-group">
                        <!--<button class="btn btn-primary" name="btnPrev" id="btnPrev" (click)="GoPrev()">{{ 'Prev'| translate}} </button>-->
                        <button class="btn btn-primary btnNext" name="btnNext" id="btnNext" (click)="GoNext(insuredForm.valid)">{{ 'Next'|translate}} </button>
                    </div>
                </div>

                <div class="clears">

                </div>

            </div>


        </div>

    </div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/InsuredBasicInfo/InsuredBasicInfo.html